import classNames from 'classnames'
import setupTouchPunch from './jquery-ui/touch-punch'
window.classNames = classNames

import $ from 'jquery'
import {} from 'jquery-ujs'

window.$ = $
window.jQuery = $

// Setup Jquery-UI

import 'jquery-ui/core'
import 'jquery-ui/widget'
import 'jquery-ui/mouse'
import 'jquery-ui/sortable'
import 'jquery-ui/draggable'
import 'jquery-ui/resizable'
import 'jquery-ui/droppable'
import 'jquery-ui/slider'

setupTouchPunch()

import setupI18n from './setup-i18n'
setupI18n()
